import { Card, CardContent } from '@/components/ui/card'
import { formatCurrency, cn } from '@/lib/utils'

interface BalanceCardProps {
  balance: string
  label?: string
}

export default function BalanceCard({ balance, label = 'Current Balance' }: BalanceCardProps) {
  const amount = parseFloat(balance)
  const isPositive = amount >= 0

  return (
    <Card className="relative overflow-hidden border-0 bg-card">
      {/* Subtle glow effect */}
      <div
        className={cn(
          'absolute inset-0 opacity-[0.07] blur-2xl',
          isPositive
            ? 'bg-gradient-to-br from-positive via-primary to-positive'
            : 'bg-gradient-to-br from-destructive via-destructive to-destructive'
        )}
      />

      {/* Top accent line */}
      <div
        className={cn(
          'absolute inset-x-0 top-0 h-px',
          isPositive
            ? 'bg-gradient-to-r from-transparent via-positive/50 to-transparent'
            : 'bg-gradient-to-r from-transparent via-destructive/50 to-transparent'
        )}
      />

      <CardContent className="relative pt-6">
        <p className="text-sm font-medium text-muted-foreground">{label}</p>
        <p
          className={cn(
            'mt-2 text-4xl font-bold tracking-tight',
            isPositive ? 'text-positive' : 'text-destructive'
          )}
        >
          {formatCurrency(amount)}
        </p>
        <p className="mt-1.5 text-xs text-muted-foreground">
          {isPositive ? 'Amount owed to you' : 'Amount you owe'}
        </p>
      </CardContent>
    </Card>
  )
}
